import Login from "pages/Auth/Login";
import Register from "pages/Auth/Register";
import Dashboard from "pages/Dashboards/Dashboard";
import Deal from "pages/Deal/Deal";
import Margin_Management from "pages/Margin_Management/Margin_Management";
import Publishers from "pages/Publishers/Publishers";
import InsertionOrders from "pages/InsertionOrders/InsertionOrders";
import ReactBSTables from "pages/tables/ReactBSTables";
import Sortable from "pages/tables/Sortable";
import Tables from "pages/tables/Tables";
import { ROLES } from "variables/constants";
import AddPublisher from "pages/Publishers/AddPublisher";
import Tags from "pages/Tags/Tags";
import ProductTypes from "pages/Settings/ProductTypes";
import Profile from "pages/Settings/Profile";
import Actions from "pages/Publisher_Actions/Actions";
import Reporting from "pages/Publisher_Reporting/Reporting";
import Publisher_Billing from "pages/Publisher_Billing/Publisher_Billing";
import Publisher_Tags from "pages/Publisher_Tags/Publisher_Tags";
import Admin_Reporting from "pages/Admin_Reporting/Admin_Reporting";
import DealDetails from "pages/Deal/DealDetails";
import PublisherDetails from "pages/Publishers/PublisherDetails";
import InsertionOrderDetails from "pages/InsertionOrders/InsertionOrderDetails";
import UserList from "pages/User/UserList";
import Data from "pages/Data/Data";
import Reporting_Raw from "pages/Admin_Reporting/Reporting_Raw";
import Publisher_UserList from "pages/User/Publisher_UserList";
import LedgerManagement from "pages/Ledger/Ledger";
import PublisherAdvance from "pages/Ledger/PublisherAdvance";
import PublisherLedger from "pages/Publisher_Ledger/PublisherLedger";
import InvoiceList from "pages/Invoices/InvoiceList";
import InvoiceDetails from "pages/Invoices/InvoiceDetails";
import PublisherBankDetails from "pages/Publishers/PublisherBankDetail";
import BankDetails from "pages/Publishers/BankInfoDetails";
import Publisher_Advance from "pages/Publisher_Advance/Publisher_Advance";
import RerunLogs from "pages/Ledger/RerunLogs";

const routes = [
  {
    show: true,
    path: "/dashboard",
    name: "Dashboard",
    icon: "fa fa-area-chart text-grey",
    component: <Dashboard />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/admin_reporting",
    name: "Admin Reporting",
    icon: "fa fa-line-chart text-grey",
    component: <Admin_Reporting />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/reporting_raw/raw",
    name: "Raw Reporting",
    icon: "ni ni-single-copy-04 text-grey",
    component: <Reporting_Raw />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "/login",
    name: "Login",
    icon: "ni ni-ungroup text-grey",
    component: <Login />,
    layout: "/auth",
    roles: [ROLES.superAdmin, ROLES.publisher, ROLES.admin, ROLES.publisher_user],
  },
  {
    show: false,
    path: "/register",
    name: "Register",
    icon: "ni ni-ungroup text-grey",
    component: <Register />,
    layout: "/auth",
    roles: [ROLES.superAdmin, ROLES.publisher, ROLES.admin, ROLES.publisher_user],
  },
  {
    show: true,
    path: "/publishers",
    name: "Publishers",
    icon: "fa fa-users text-grey",
    component: <Publishers />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "/publishers/add",
    name: "Add Publishers",
    icon: "fa fa-users text-grey",
    component: <AddPublisher />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "/publishers/details",
    name: "Publisher Details",
    component: <PublisherDetails />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/insertion-orders",
    name: "IOs",
    icon: "fa fa-file-contract text-grey",
    component: <InsertionOrders />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "/insertion-orders/details",
    name: "Publisher Details",
    component: <InsertionOrderDetails />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    collapse: true,
    name: "Deals",
    icon: "fa fa-credit-card-alt text-grey",
    state: "dealCollapse",
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
    views: [
      {
        show: true,
        path: "/deal",
        name: "Deal Management",
        miniName: "D",
        component: <Deal />,
        layout: "/admin",
        roles: [ROLES.superAdmin, ROLES.admin],
      },
      {
        show: false,
        path: "/deal/details",
        name: "Deal Details",
        miniName: "DD",
        component: <DealDetails />,
        layout: "/admin",
        roles: [ROLES.superAdmin, ROLES.admin],
      },
      {
        show: true,
        path: "/margin-management",
        name: "Margin Management",
        miniName: "M",
        component: <Margin_Management />,
        layout: "/admin",
        roles: [ROLES.superAdmin, ROLES.admin],
      },
    ],
  },
  {
    show: true,
    path: "/tags",
    name: "Tags",
    icon: "fa fa-tag text-grey",
    component: <Tags />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "profile",
    name: "Profile",
    icon: "fa fa-globe text-grey",
    component: <Profile />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.publisher, ROLES.admin, ROLES.publisher_user],
  },
  {
    show: true,
    collapse: true,
    name: "Users",
    icon: "fa fa-user text-grey",
    state: "usersCollapse",
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
    views: [
      {
        show: true,
        path: "/users",
        name: "Internal Users",
        miniName: "U",
        component: <UserList />,
        layout: "/admin",
        roles: [ROLES.superAdmin],
      },
      {
        show: true,
        path: "/publisherUsers",
        name: "Publisher Users",
        miniName: "PU",
        component: <Publisher_UserList />,
        layout: "/admin",
        roles: [ROLES.superAdmin, ROLES.admin],
      },
    ],
  },
  {
    show: true,
    path: "/data",
    name: "Data",
    icon: "fa fa-database text-grey",
    component: <Data />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/ledger-management",
    icon: "fa  fa-file-text text-grey",
    name: "Ledger",
    component: <LedgerManagement />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/invoices",
    icon: "fa fa-file-invoice text-grey",
    name: "Invoices",
    component: <InvoiceList />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: false,
    path: "/invoices/details",
    icon: "fa fa-file-invoice text-grey",
    name: "Invoice Details",
    component: <InvoiceDetails />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    path: "/publisher-advance",
    icon: "fa  fa-file-text text-grey",
    name: "Publisher Advance",
    component: <PublisherAdvance />,
    layout: "/admin",
    roles: [ROLES.superAdmin, ROLES.admin],
  },
  {
    show: true,
    name: "Publisher Banks",
    icon: "fa fa-bank text-grey",
    roles: [ROLES.superAdmin, ROLES.admin],
    component: <PublisherBankDetails />,
    layout: "/admin",
    path: "/publisher_bank",
  },
  //   {
  //   show: true,
  //   name: "Rerun Logs",
  //   icon: "fa fa-bank text-grey",
  //   roles: [ROLES.superAdmin, ROLES.admin],
  //   component: <RerunLogs />,
  //   layout: "/admin",
  //   path: "/ledger_rerun_logs",
  // },
    {
    show: false,
    name: "Bank Details",
    roles: [ROLES.superAdmin, ROLES.admin],
    component: <BankDetails />,
    layout: "/admin",
    path: "/publisher_bank/details",
  },

    {
    show: true,
    collapse: true,
    name: "Settings",
    icon: "fa fa-gear text-grey",
    state: "settingsCollapse",
    layout: "/admin",
    roles: [ROLES.superAdmin],
    views: [
      {
        show: true,
        path: "/product-types",
        name: "Product Types",
        miniName: "P",
        component: <ProductTypes />,
        layout: "/admin",
        roles: [ROLES.superAdmin],
      },
    ],
  },

  //============Publisher Routes=======
  {
    show: true,
    path: "/dashboard",
    name: "Dashboard",
    icon: "fa fa-area-chart text-grey",
    component: <Dashboard />,
    layout: "/publisher",
    roles: [ROLES.publisher, ROLES.publisher_user],
  },
  {
    show: true,
    name: "Reporting",
    icon: "fa fa-line-chart text-grey",
    roles: [ROLES.publisher, ROLES.publisher_user],
    component: <Reporting />,
    layout: "/publisher",
    path: "/reporting",
  },
  {
    show: true,
    name: "Actions",
    icon: "fa fa-tasks text-grey",
    roles: [ROLES.publisher, ROLES.publisher_user],
    component: <Actions />,
    layout: "/publisher",
    path: "/actions",
  },
  {
    show: true,
    name: "Tags",
    icon: "fa fa-tag text-grey",
    roles: [ROLES.publisher, ROLES.publisher_user],
    component: <Publisher_Tags />,
    layout: "/publisher",
    path: "/publisher_tags",
  },
  {
    show: true,
    name: "Publisher Billing",
    icon: "fa fa-university text-grey",
    roles: [ROLES.publisher, ROLES.publisher_user],
    component: <Publisher_Billing />,
    layout: "/publisher",
    path: "/publisher_billing",
  },
  {
    show: true,
    name: "Ledger",
    icon: "fa fa-file text-grey",
    roles: [ROLES.publisher, ROLES.publisher_user],
    component: <PublisherLedger />,
    layout: "/publisher",
    path: "/publisher_ledger",
  },
  // {
  //   show: true,
  //   path: "/publisher-advance",
  //   icon: "fa  fa-file-text text-grey",
  //   name: "Advance",
  //   component: <Publisher_Advance />,
  //   layout: "/publisher",
  //   roles: [ROLES.publisher, ROLES.publisher_user],
  // },

  // {
  //   show: true,
  //   collapse: true,
  //   name: "Tables",
  //   icon: "ni ni-align-left-2 text-default",
  //   state: "tablesCollapse",
  //   roles: [ROLES.superAdmin, ROLES.publisher],
  //   views: [
  //     {
  //       show: true,
  //       path: "/tables",
  //       name: "Tables",
  //       miniName: "T",
  //       component: <Tables />,
  //       layout: "/admin",
  //       roles: [ROLES.superAdmin, ROLES.publisher],
  //     },
  //     {
  //       show: true,
  //       path: "/sortable",
  //       name: "Sortable",
  //       miniName: "S",
  //       component: <Sortable />,
  //       layout: "/admin",
  //       roles: [ROLES.superAdmin, ROLES.publisher],
  //     },
  //     {
  //       show: true,
  //       path: "/react-bs-table",
  //       name: "React BS Tables",
  //       miniName: "RBT",
  //       component: <ReactBSTables />,
  //       layout: "/admin",
  //       roles: [ROLES.superAdmin, ROLES.publisher],
  //     },
  //   ],
  // },
  // {
  //   collapse: true,
  //   name: "Examples",
  //   icon: "ni ni-ungroup text-orange",
  //   state: "examplesCollapse",
  //   views: [
  //     {
  //       path: "/login",
  //       name: "Login",
  //       miniName: "L",
  //       component: <Login />,
  //       layout: "/auth",
  //     },
  //     {
  //       path: "/register",
  //       name: "Register",
  //       miniName: "R",
  //       component: <Register />,
  //       layout: "/auth",
  //     },
  //   ],
  // },
];

export default routes;
